import { PlacementQuestion } from "../types/PlacementQuestion";
import api from "./api";

export const getPlacementQuestions = async () => {
  try {
    const response = await api.get("/placement-questions");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch placementQuestions", error);
    throw error;
  }
};

export const getPlacementQuestion = async (id: string) => {
  try {
    const response = await api.get(`/placement-questions/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch placementQuestion", error);
    throw error;
  }
};

export const createPlacementQuestion = async (
  placementQuestion: PlacementQuestion
) => {
  try {
    const response = await api.post("placement-questions", placementQuestion, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving placementQuestion:", error);

    throw error;
  }
};

export const updatePlacementQuestion = async (
  placementQuestionId: string,
  updatedData: PlacementQuestion
) => {
  try {
    const response = await api.put(
      `placement-questions/${placementQuestionId}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating placementQuestion:", error);
    throw error;
  }
};

export const deletePlacementQuestion = async (
  placementQuestion: PlacementQuestion
) => {
  try {
    const response = await api.delete(
      `placement-questions/${placementQuestion._id}`,
      {
        params: { difficulty: placementQuestion.difficulty },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting placementQuestion:", error);
    throw error;
  }
};
